import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, ClockIcon, ShieldAlertIcon } from 'lucide-react';
const problems = [{
  icon: AlertTriangleIcon,
  title: 'Miedo a trabajos mal hechos',
  description: 'Incertidumbre sobre la calidad de los materiales y la ejecución de la obra.'
}, {
  icon: ClockIcon,
  title: 'Poca claridad en precios y tiempos',
  description: 'Presupuestos que cambian a mitad de camino y plazos que nunca se cumplen.'
}, {
  icon: ShieldAlertIcon,
  title: 'Falta de respaldo después de terminar la obra',
  description: 'Maestros que desaparecen si surge un problema meses después de entregado el trabajo.'
}];
export function Problem() {
  return <section id="problema" className="py-20 bg-concrete" data-id="element-109">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-111">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-112">
            Elegir a quién confiar una construcción no es una decisión menor
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-lg text-gray-600 leading-relaxed" data-id="element-113">
            Cuando se trata de construir, remodelar o mejorar un espacio, la
            confianza es clave. No basta con recibir un precio rápido: necesitas
            claridad, respaldo y una forma seria de evaluar el trabajo antes de
            avanzar.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-114">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1 + 0.2
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-115">
              <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center mb-6 text-red-500" data-id="element-116">
                <problem.icon className="w-6 h-6" data-id="element-117" />
              </div>
              <h3 className="text-xl font-bold text-navy mb-3" data-id="element-118">
                {problem.title}
              </h3>
              <p className="text-gray-600" data-id="element-119">{problem.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}